import { render, staticRenderFns } from "./latest-scan.vue?vue&type=template&id=72be1523"
import script from "./latest-scan.vue?vue&type=script&lang=js"
export * from "./latest-scan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports